import { defineComponent, mergeModels, useModel, computed, createBlock, openBlock, withCtx, createVNode, mergeProps, createTextVNode, toDisplayString, createElementVNode, createCommentVNode, defineAsyncComponent } from "vue";
import { ROUTES, VuetifyValidationRules } from "@editor/ui-utils";
import { QSelect, QItemSection, QItem, QInput } from "quasar";
import { TAG_OPTIONS } from "@modules/news-article-utils";
import { useI18n } from "vue-i18n";
import { useEditorContent } from "@modules/news-article-editor-ui-components";
const de = {
  articles: {
    routeTitle: "Artikel",
    routeDetailTitle: "A: ",
    backToList: "Zurück zur Artikelliste",
    settings: "Einstellungen",
    content: "Inhalt",
    preview: "Vorschau",
    basics: "Basics",
    saveKeepPublished: "Speichern & veröffentlicht lassen",
    savePublish: "Veröffentlichen",
    saveScheduled: "Veröffentlichung planen",
    saveOffline: "Artikel offline nehmen",
    saveRescheduled: "Speichern & Änderungen planen",
    publishAt: "Änderungen veröffentlichen um",
    scheduleChanges: "Änderungen planen",
    saveDraft: "Als Entwurf speichern",
    messageSaved: "Artikel gespeichert",
    deleteArticle: "Artikel löschen",
    messagePublishTitle: "Artikel veröffentlichen",
    messagePublish: "Bist du sicher, dass du den Artikel veröffentlichen möchtest?",
    messageUnpublishTitle: "Artikel offline nehmen",
    invalidOperation: "Ungültiger Vorgang",
    invalidOrigin: 'Der Bildursprung darf nicht "xymatic" sein',
    backToArticle: "Zurück zum Artikel",
    messageAutoImageTitle: "Bilder automatisch importieren",
    messageAutoImage: "Möchtest du das Teaserbild und weitere Bilder automatisch importieren?",
    messageAutoImageConfirm: "Ja, importieren",
    messageAutoImageCancel: "Nein",
    messageDeleteArticleTitle: "Artikel löschen",
    messageDeleteArticle: "Bist du dir sicher, dass du den Artikel löschen möchtest?",
    messageConfirmUnpublishArticle: "Bist du sicher, dass du den Artikel offline nehmen möchtest?",
    messageConfirmDraftArticle: "Bist du sicher, dass du den Artikel als entwurf speichern möchtest?",
    messageRepublishInFuture: "Möchten Sie den Artikel wirklich offline nehmen und für die zukünftige Veröffentlichung planen?",
    messageRepublishInFutureTitle: "Veröffentlichung neu planen",
    errorPreventSaveAsDraft: 'Du kannst einen Artikel nicht als Entwurf speichern, wenn ein Veröffentlichungsdatum festgelegt ist. Bitte setze die Box auf "Kein Veröffentlichungsdatum" oder klicke auf "Speichern & Veröffentlichen".',
    errorMandatoryFields: "Entschuldigung, du kannst den Artikel nicht speichern, weil nicht alle Pflichtfelder ausgefüllt sind",
    errorPublishDateAfterSchedule: "Das Veröffentlichungsdatum darf nicht nach dem geplanten Änderungsdatum liegen",
    errorDisplayDateAfterSchedule: "Sie können kein Anzeigedatum nach dem geplanten Änderungsdatum festlegen",
    errorScheduleDateLessThenNow: "Das geplante Änderungsdatum sollte in der Zukunft liegen",
    errorScheduleDateInPast: "Das Anzeigedatum darf nicht in der Zukunft liegen.",
    errorUnpublishDateBeforeSchedule: "Das Datum der Depublikation darf nicht vor dem geplanten Änderungsdatum liegen",
    errorUnpublishDateBeforeScheduleWithAlreadyUnpublishDate: "Das geplante Änderungsdatum kann nicht nach dem ursprünglichen Veröffentlichungsdatum liegen, wenn das Veröffentlichungsdatum entfernt wird.",
    errorAMPValidation1: "Artikel ",
    errorAMPValidation2: "wurde aktualisiert aber die AMP Validierung ist fehlgeschlagen.",
    errorAssetLicense: "Die Veröffentlichung von Assets ist nicht erlaubt. Prüfen Sie die Lizenz der Asset-Marke.",
    modeUnpublished: "Offline genommen",
    modeScheduled: "Veröffentlichung geplant",
    modePublished: "Veröffentlicht",
    modeDraft: "Entwurf",
    removeArticle: "Artikel anzeigen",
    versions: "Versionen",
    previewMobile: "Mobile",
    previewTablet: "Tablet",
    previewDesktop: "Desktop",
    migration: "Migration",
    hasAffiliateActivated: "Dieser Artikel wurde als Affiliateartikel markiert, da er Affiliatelinks enthält.",
    noEditTooltip: "Dieser Artikel stammt ursprünglich vom {source}-Editor",
    addSelectedArticlesButton: "ausgewählte Artikel hinzufügen",
    cancelButton: "Abbrechen",
    updateShownDateCheckbox: "Shown Date aktualisieren",
    updatePublishDateCheckbox: "Veröffentlichungsdatum aktualisieren",
    handledInLegacySystem: "Dieser Artikel wird in {source} bearbeitet, Sie können ihn nicht auf Vibe bearbeiten",
    changedByUnknownAuthor: "unbekannter Autor",
    changedByScheduledUpdate: "geplante Änderungen",
    select: "Artikel auswählen",
    cvdTagButton: "CVD Tag",
    cvdTagLabel: "In CVD Tag speichern",
    messageSavedCvdTag: "CVD Tag gespeichert",
    cvdTagNoneOption: "Kein Zuordnung"
  },
  articlesSettings: {
    noIndexActivated: "No index wurde aktiviert",
    leadText: "Vorspann",
    seoDescription: "Meta Description",
    seoDescriptionEdited: "Meta Description (geändert)",
    peopleInArticle: "Personen im Artikel",
    backgroundArticles: "Mehr zum Thema - Artikel",
    adArticle: "Artikel als Anzeige markieren",
    adsEnabled: "Werbung aktivieren",
    isOutstreamEnabled: "Outstream aktiveren",
    withTableOfContents: "mit Inhaltsverzeichnis",
    ampEnabled: "AMP aktiviert",
    hideFromNewsticker: "Nicht im Newsticker anzeigen",
    hideFromTeaserList: "Nicht im teaser listing anzeigen",
    checkValidation: "Validierung prüfen",
    msn: "MSN Service",
    magazine: "Inhalt aus dem BUNTE-Magazin",
    adTags: "Werbetags",
    trackingTags: "Tracking-Tags",
    weight: "Wichtigkeit",
    showPartnerLogo: "Partnerlogo anzeigen",
    isBought: "Artikel gekauft",
    seoUrlSettings: "URL & SEO",
    canonicalUrl: "Canonical URL",
    slug: "URL-Slug",
    noIndex: "NoIndex aktivieren",
    toArticle: "Zum Artikel",
    author: "Autor",
    createdBy: "Erstellt von",
    messageAMPSuccess: "AMP Validierung war erfolgreich",
    messageAMPFailed: "AMP Validierung fehlgeschlagen",
    messageAMPFailedMandatory: "AMP Validierung fehlgeschlagen weil nicht alle Pflichtfelder ausgefüllt sind",
    messagePreviewTitle: "Artikel nicht gespeichert",
    messagePreview: "Um die Artikelpreview zu sehen, musst du den Artikel erst speichern.",
    messagePreviewCancel: "Ok",
    messageNotSavedTitle: "Nicht gespeicherte Änderungen",
    messageNotSaved: "Um den Artikel zu öffnen und deine Änderungen zu sehen, musst du die Änderungen erst speichern.",
    messageNotSavedCancel: "Zurück zum Editor",
    messageNotSavedButton: "Trotzdem öffnen",
    bfJobTitle: "Jobteam",
    source: "Quelle",
    showMostReadArticles: "Zeige die Meistgelesen-Stage",
    general: "Allgemein",
    originalSourceUrl: "Kuratierte URL",
    unpublishDateValidationMessage: "Das Datum der Annullierung der Veröffentlichung darf nicht vor dem Datum der Veröffentlichung liegen.",
    hasAdvertisementMarkTooltip: "Artikel als Anzeige markieren",
    publishDateBeforeConfirmationDialog: "Das geänderte Veröffentlichungsdatum liegt vor dem letzten Veröffentlichungsdatum. Sind Sie sicher, dass Sie dieses Datum festlegen möchten?",
    publishDateConfirmationDialog: "Wenn du ein zukünftiges Datum für die Veröffentlichung setzt, wird der Artikel dadurch automatisch offline genommen und zum gewünschten Zeitpunkt erneut veröffentlicht. Willst du, dass der Artikel bis zum gewünschten Zeitpunkt in unveränderter Form online bleibt, benutze jetzt den Button „Speichern und Änderungen planen“ Bist du sicher, dass du ein zukünftiges Veröffentlichungsdatum setzen möchtest?",
    shownAfterPublicationDateValidationMessage: "Ihr Artikel ist zur Veröffentlichung geplant, das Anzeigedatum muss auf das Veröffentlichungsdatum gesetzt werden.",
    shownAfterCurrentDateValidationMessage: "Das Anzeigedatum darf nicht in der Zukunft liegen.",
    shownBeforePublicationDateValidationMessage: "Das angegebene Datum darf nicht vor dem Datum der Veröffentlichung liegen.",
    publishDateChangeAfterPublished: "Warnung: Änderung des Datums der Veröffentlichung nur in Absprache mit dem SEO-Team!",
    originalBrand: "Originalmarke",
    originalArticleUrl: "URL des Originalartikels"
  },
  newsArticleList: {
    title: "Artikel",
    newButton: "Neuer Artikel",
    multiLabel: "Ausgewählte Artikel speichern",
    search: "Nach Hauptzeile, Vorzeile oder Legacy-ID suchen",
    myArticles: "Meine Artikel",
    includeSubchannels: "Subchannel miteinbeziehen",
    statusDropdown: "Status",
    statusAll: "Alle",
    statusDraft: "Entwurf",
    statusSchedule: "Geplant",
    statusPublished: "Veröffentlicht",
    statusUnpublish: "Depubliziert",
    typeDropdown: "Typ",
    typeAll: "Alle",
    typeImages: "Bilder",
    typeVideos: "Videos",
    typeGalleries: "Galerien",
    displayDateFrom: "Zeige von",
    displayDateTo: "Zeige bis",
    displayPeriod: "Zeitraum",
    isPremium: "Nur Premiumartikel",
    isBought: "Artikel gekauft",
    contentPartner: "Content Partner",
    loading: "Lade Artikel",
    deleteArticle: "Artikel löschen",
    headerStatus: "Status",
    headerKickerTitle: "Vorzeile, Hauptzeile",
    headerChannel: "Channel",
    headerPublished: "Shown date",
    headerChanged: "Geändert",
    headerAMP: "AMP",
    headerBrand: "Marke",
    headerAMPDescription: "Grüner Haken: Die AMP-Version des Artikels ist valide. Damit funktioniert er auf allen Google-Plattformen.\nRotes Kreuz: Der Artikel enthält Elemente, welche die AMP invalidieren. Bitte nochmals prüfen.",
    multiSelect: "Auswählen",
    dpEdit: "Bearbeiten",
    dpGoToArticle: "Zum Artikel",
    duplicateArticle: "Artikel duplizieren",
    dpDelete: "Artikel löschen",
    messageNoSelfLink: "Artikel kann nicht auf sich selbst verlinken",
    messageDelete1: "Bist du sicher, dass du den Artikel",
    messageDelete2: "löschen willst?",
    messageDeleteSuccess: "Artikel gelöscht",
    editNewTab: "In neuem Tab bearbeiten",
    scheduledChangeToolTipMessage: "Geplante Aktualisierungen dieses Artikels sind geplant",
    authorshipType: "Urheberschaftstyp",
    authorshipTypeAll: "Alle",
    authorshipTypeNewsArticle: "Nachrichtenartikel",
    authorshipTypePartnerArticle: "Partnerartikel",
    authorshipTypeCrossPublishArticle: "Cross-Publish-Nachrichtenartikel",
    authorshipTypeAgencyArticle: "Agenturartikel",
    excludeFeedsLabel: "Feeds ausschließen",
    excludeFeedsNone: "Keine",
    noTagFilterLabel: "Alle Artikel"
  },
  articlesEdit: {
    kicker: "Vorzeile (für Chip.de bitte nicht ausfüllen)",
    title: "Hauptzeile",
    people: "Personen",
    leadText: "Vorspann",
    words: "Wörter",
    chars: "Buchstaben",
    addContent: "Element hinzufügen",
    remove: "Entfernen",
    externalSource: "Externe Quelle",
    excludedSources: "Ausgeschlossene externe Artikelquelle",
    channel: "Channel",
    articleTitle: "Artikel Titel",
    seoTitle: "SEO-Zeile",
    articleType: "Hauptelement",
    image: "Bild",
    video: "Video",
    gallery: "Galerie",
    imageSelector: "Hauptbild auswählen oder hochladen",
    mainImageTitle: "Hauptbild",
    mainVideoTitle: "Hauptvideo",
    teaserVideoTitle: "Hauptvideo",
    teaserImageTitle: "Teaserbild",
    mainImageTitleTooltip: "Das Hauptbild wird auf der Artikelseite angezeigt.",
    mainVideoTitleTooltip: "Das Hauptbild wird auf der Artikelseite angezeigt.",
    teaserVideoTitleTooltip: "Das Hauptvideo wird auf der Artikelseite angezeigt.",
    teaserImageTitleTooltip: "Das Teaserbild wird auf Channelseiten angezeigt.",
    teaserImageSelector: "Teaserbild auswählen oder hochladen",
    teaserInfo: "Wenn kein Teaserbild vorhanden ist, wird das Hauptbild auf Channelseiten benutzt",
    teaserInfoVideo: "Wenn kein Teaserbild vorhanden ist, wird das Videobild auf Channelseiten benutzt",
    gallerySelector: "Galeriebild",
    teaserGalleryTitle: "Galeriebilder",
    teaserGalleryMainImageTitle: "Hauptbild",
    teaserGalleryMainImageLabel: "Hauptbild auswählen oder hochladen",
    teaserGalleryMainImageCheckbox: "Zur Galerie hinzufügen",
    teaserGalleryMainImageCheckboxTooltip: "Das Hauptbild wird der gewählten Galerie hinzugefügt.",
    gallerySelectorTooltip: "Das Galeriebild wird auf der Artikelseite angezeigt.",
    teaserGalleryMainImageTitleTooltip: "Das Hauptbild ist optional.",
    teaserImageGallery: "Teaserbild auswählen oder hochladen",
    dateSettingsTitle: "Veröffentlichung",
    showFirstPublishDate: "Erstveröffentlichungsdatum anzeigen",
    videoAutoplay: "Autoplay",
    articleDisplayDate: "Shown date",
    noPublishDate: "Veröffentlichung terminieren",
    setPublishDate: "Publish date",
    setUnpublishDate: "Offline nehmen am",
    relatedDeleted: "Gelöscht",
    relatedExpired: "Abgelaufen",
    relatedWeight: "Wichtigkeit",
    relatedRemove: "Entfernen",
    relatedPlaceHere: "Artikel hier platzieren",
    relatedPrioAd: "AD",
    relatedPrioInside: "LOGIN",
    relatedArticleAdd: "Artikel verlinken",
    seoPerfect: "Perfekte Länge",
    seoOkay: "In Ordnung, kürzen wenn möglich",
    seoLong: "Zu lang, bitte kürzen!",
    length: "Länge",
    desktopAlertTitle: "Es ist ein Fehler aufgetreten",
    desktopAlertDescription: "Deine Auflösung ist aktuell zu gering, um die Desktop Vorschau anzuzeigen.<br/>Bitte minimiere das Menü auf der linken Seite, um das Anzeigen zu ermöglichen.",
    addPeople: "Personen verlinken",
    sourceTracking: "Benutzerdefinierte Nachverfolgung",
    communityTracking: "Community Zuordnung",
    seoDescriptionLabel: "Bist du sicher, dass du die Meta Description ändern möchtest? Dies führt dazu, dass künftige Änderungen der Inhalte nicht mehr automatisch in die Meta Description übernommen werden.",
    seoDescriptionConfirm: "OK",
    seoDescriptionCancel: "Abbrechen",
    teaserDialogTitle: "Teaser-Texte deaktivieren",
    teaserDialogMsg: "Sind Sie sicher, dass Sie die unterschiedliche Teaser-Texte deaktivieren wollen? Dies führt dazu, dass die Texte nach dem Speichern des Artikels nicht mehr verwendet werden.",
    teaserDialogConfirm: "OK",
    teaserDialogCancel: "Abbrechen",
    teaserEnabled: "Eingabefelder für Teaser erstellt",
    updateShownDateCheckboxHint: "Shown Date wird bei Speichern oder Veröffentlichen automatisch aktualisier.",
    updatePublishDateCheckboxHint: "Aktualisiert das Veröffentlichungsdatum automatisch auf das ausgewählte Datum für die Änderung.",
    linkTags: "Tags verlinken",
    articlePushHistory: "Push-/Eil-Historie anzeigen",
    feedSettings: {
      title: "Feeds",
      description: "Der Artikel wird in den folgenden Feeds erscheinen:",
      options: {
        include: "Ja",
        exclude: "Nein",
        auto: "Automatisch"
      }
    },
    selectedPartnerImageWarning: "Sie haben ein Partnerbild ausgewählt. Dieses Bild darf nur in dem entsprechenden Partnerartikel verwendet werden."
  },
  articleBlocks: {
    ctaLayout: "Layout",
    ctaButton: "Button",
    ctaStickyButton: "Sticky Button",
    ctaBox11: "Box 1:1",
    ctaBox11Info: "Box mit Bild im 1:1 Format",
    ctaBox169: "Box 16:9",
    ctaBox169Info: "Box mit Bild im 16:9 Format",
    ctaTitle: "Titel",
    ctaButtonText: "Button Text (17 Zeichen Limit)",
    ctaLink: "Button Link",
    ctaIsAffiliate: "Zeige Affiliate-Disclaimer",
    noFollow: "No Follow",
    noFollowTooltip: 'Der Link wird als "nofollow" gekennzeichnet. Bitte für werbliche Links immer nofollow auswählen.',
    blockTeaser: "Article Teaser",
    imageUrl: "Bild-URL",
    imagePlaceholder: "Link-URL einfügen (muss mit https:// beginnen)",
    hasAffiliate: "Affiliate-Link",
    hasAffiliateTooltip: "Ist ein Link als Affiliate-Link gekennzeichnet, erscheint am Anfang des Artikels die Affiliate Disclaimer-Box und das Element wird als Anzeige markiert.",
    newTab: "In neuem Tab öffnen",
    bound: "Bündig",
    boundTooltip: "Per default ist der Banner freigestellt und nicht bündig mit dem nachfolgendem Block.",
    becomeInsider: "INSIDER werden und direkt weiterlesen",
    loginwallText: "Nutzer können sich hier registrieren um mehr Inhalte zu sehen. Eingeloggten Benutzern wird dieses Element nicht angezeigt.",
    quoteAuthor: "Zitat von",
    scriptBlock: "Benutzerdefiniertes JavaScript einfügen (wird nicht auf AMP angezeigt). Bitte Auswirkungen auf DSGVO beachten.",
    rawBlock: "Benutzerdefiniertes JavaScript einfügen (auf AMP angezeigt). Bitte Auswirkungen auf DSGVO beachten.",
    highlightBox: "Highlight Box",
    labelText: "Textfeld",
    labelImage: "Bild",
    labelGallery: "Galerie",
    labelVideo: "Video",
    labelArticle: "Artikel",
    labelPaywall: "Paywall",
    labelLoginwall: "Login",
    labelSocial: "Social",
    labelQuote: "Zitat",
    labelCTA: "Call to Action",
    labelNewsletter: "Newsletter Box",
    or: "ODER",
    imageLink: "Alternativ: Bild per Link einfügen",
    imageUrlStart: "Bild-URL, muss mit https:// starten",
    imagePreview: "Vorschau"
  },
  articlesVersions: {
    noVersions: "Keine Version verfügbar",
    unknownEditor: "Unbekannter Autor",
    modifiedBy: "Geändert von",
    modifiedAt: "Geändert am"
  },
  articlesMigration: {
    directEditNotice: "Bitte beachten Sie: Die hier sichtbaren Einstellungen wirken sofort und unabhängig von der Speichern-Funktion. Änderungen treten unmittelbar in Kraft.",
    source: "Herkunft",
    legacyId: "Legacy ID",
    renderedByCtf: "Darstellung durch CTF",
    editableInCtf: "Bearbeitung in Vibe",
    modifiedInCtf: "Geändert in Vibe",
    confirmModal: {
      yes: "Ja",
      cancel: "Abbrechen",
      renderedBy: {
        title: "Darstellung durch CTF ändern",
        message: "Bist du sicher, dass du das darstellende System ändern möchtest?"
      },
      editableIn: {
        title: "Bearbeitung in Vibe ändern",
        message: "Bist du sicher, dass du die Bearbeitung in Vibe erlauben möchtest? Das kann nicht rückgängig gemacht werden!"
      }
    },
    viewCtfVersion: "CTF-Version öffnen"
  },
  articleNotifications: {
    successfulMutation: {
      saved: "Artikel gespeichert",
      deleted: "Gelöscht",
      published: "Veröffentlicht",
      unpublished: "Artikel offline",
      scheduled: "Geplant",
      saveDraft: "Entwurf"
    },
    warnings: {
      empty: {
        image: "Es wurde kein Bild im Inhalt ausgewählt und durch einen Platzhalter ersetzt.",
        video: "Es wurde kein Video im Inhalt ausgewählt und durch einen Platzhalter ersetzt.",
        text: "Es existiert ein leerer Textblock im Inhalt",
        social: "Es existiert ein leerer Socialblock im Inhalt und wird durch einen Platzhalter ersetzt.",
        gallery: "Es existiert eine leere Gallerie im Inhalt und wird durch einen Platzhalter ersetzt.",
        chipWidget: "Es gibt einen leeren Chip-Widget-Block, der beim Speichern entfernt wird.",
        cwcWidget: "Es gibt einen leeren Cwc-Widget-Block, der beim Speichern entfernt wird.",
        inpageWidget: "Es gibt einen leeren Inpage-Widget-Block, der beim Speichern entfernt wird.",
        backgroundArticle: "Es existiert eine leere Hintergrund Article im Inhalt und wird durch einen Platzhalter ersetzt."
      }
    }
  }
};
const en = {
  articles: {
    routeTitle: "Articles",
    routeDetailTitle: "A: ",
    backToList: "Back to Article list",
    settings: "Settings",
    content: "Content",
    preview: "Preview",
    basics: "Basics",
    saveKeepPublished: "Save & Keep Published",
    savePublish: "Publish",
    saveScheduled: "Schedule publication",
    saveRescheduled: "Save & Schedule changes",
    scheduleChanges: "Schedule changes",
    publishAt: "Publish at",
    saveOffline: "Take offline",
    saveDraft: "Save as Draft",
    deleteArticle: "Delete Article",
    messagePublishTitle: "Publish Article",
    messagePublish: "Are you sure you want to publish this article?",
    messageUnpublishTitle: "Take article offline",
    invalidOperation: "Invalid operation",
    invalidOrigin: "Image origin cannot be xymatic",
    backToArticle: "Back to article",
    messageSaved: "Article saved",
    messageAutoImageTitle: "Automatically import images",
    messageAutoImage: "Do you want to import the teaser image and other images automatically?",
    messageAutoImageConfirm: "Yes, import",
    messageAutoImageCancel: "No",
    messageDeleteArticleTitle: "Delete Article",
    messageDeleteArticle: "Are you sure you want to delete this article?",
    messageConfirmUnpublishArticle: "Are you sure you want to take article offline?",
    messageConfirmDraftArticle: "Are you sure you want to set as draft?",
    messageRepublishInFuture: "Are you sure you want to take article offline and schedule it to be published in the future?",
    messageRepublishInFutureTitle: "Reschedule publishing",
    errorPreventSaveAsDraft: `You can't save an article as draft if a publish date is set. Please check the box "Publish date" or click "Save & Publish".`,
    errorMandatoryFields: "Sorry, you can't save this article because it's missing mandatory information",
    errorPublishDateAfterSchedule: "You can’t set a publish date after the scheduled change date",
    errorScheduleDateLessThenNow: "The scheduled change date should be set in the future",
    errorDisplayDateAfterSchedule: "You can’t set a display date after the scheduled change date",
    errorScheduleDateInPast: "The display date can’t be sent in the future",
    errorUnpublishDateBeforeSchedule: "Unpublish date can’t be set before the scheduled change date",
    errorUnpublishDateBeforeScheduleWithAlreadyUnpublishDate: "The scheduled change date cannot be set after the initial unpublish date if the unpublish date is being removed.",
    errorAMPValidation1: "Article",
    errorAMPValidation2: "was updated but the AMP validation failed",
    errorAssetLicense: "Asset publish is not permitted. Check asset brand license.",
    modeUnpublished: "Article offline",
    modeScheduled: "Publishing date scheduled",
    modePublished: "Published",
    modeDraft: "Draft",
    removeArticle: "Show Article",
    versions: "Versions",
    previewMobile: "Mobile",
    previewTablet: "Tablet",
    previewDesktop: "Desktop",
    migration: "Migration",
    hasAffiliateActivated: "This article has been marked as affiliate, because it contains affiliate links.",
    noEditTooltip: "This article is originally from the {source} editor",
    addSelectedArticlesButton: "Add selected articles",
    cancelButton: "Cancel",
    updateShownDateCheckbox: "Update shown date",
    updatePublishDateCheckbox: "Update publish date",
    handledInLegacySystem: "This article is being handled in {source}, you can't edit it on Vibe",
    changedByUnknownAuthor: "unknown author",
    changedByScheduledUpdate: "scheduled changes",
    select: "Select Article",
    cvdTagButton: "CVD Tag",
    cvdTagLabel: "Save to CVD Tag",
    messageSavedCvdTag: "CVD tag saved",
    cvdTagNoneOption: "None"
  },
  articlesSettings: {
    noIndexActivated: "No index was activated",
    leadText: "Lead Text",
    seoDescription: "Meta Description",
    seoDescriptionEdited: "Meta Description (edited)",
    peopleInArticle: "People within Article",
    backgroundArticles: "Background Articles",
    adArticle: "Mark as ad",
    adsEnabled: "Ads enabled",
    isOutstreamEnabled: "Outstream enabled",
    withTableOfContents: "With Table of Contents",
    ampEnabled: "AMP enabled",
    hideFromNewsticker: "Hide from newsticker",
    hideFromTeaserList: "Hide from most recent",
    checkValidation: "Check validation",
    msn: "MSN Service",
    magazine: "Content from BUNTE-Magazin",
    adTags: "Ad tags",
    trackingTags: "Tracking tags",
    weight: "Weight",
    showPartnerLogo: "Show partner logo",
    isBought: "Article bought",
    seoUrlSettings: "URL & SEO",
    canonicalUrl: "Canonical URL",
    slug: "URL Slug",
    noIndex: "Activate NoIndex",
    toArticle: "To Article",
    author: "Author",
    createdBy: "Created by",
    messageAMPSuccess: "AMP validation was successful",
    messageAMPFailed: "AMP validation failed",
    messageAMPFailedMandatory: "AMP validation failed because not all mandatory fields are filled",
    messagePreviewTitle: "Article not saved",
    messagePreview: "Please save your article to see changes in preview.",
    messagePreviewCancel: "Ok",
    messageNotSavedTitle: "Unsaved changes",
    messageNotSaved: "You need to save before you can open the article and display the changes.",
    messageNotSavedCancel: "Back to editor",
    messageNotSavedButton: "Open anyway",
    bfJobTitle: "Job team",
    source: "Source",
    showMostReadArticles: "Show the most read articles block",
    general: "General",
    originalSourceUrl: "Curated URL",
    unpublishDateValidationMessage: "The date of cancellation of publication must not precede the date of publication.",
    hasAdvertisementMarkTooltip: 'Shows "Anzeige" label.',
    publishDateBeforeConfirmationDialog: "The changed publication date is before the last publication date. Are you sure you want to set this date?",
    publishDateConfirmationDialog: "If you set a future publication date, the article will automatically be taken offline and republished at the desired time. If you want the article to remain online in its current form until the desired time, use the 'Save and Schedule Changes' button now. Are you sure you want to set a future publication date?",
    shownAfterPublicationDateValidationMessage: "Your article is scheduled for publication, display date must be set to the publish date.",
    shownAfterCurrentDateValidationMessage: "The display date can’t be set in the future.",
    shownBeforePublicationDateValidationMessage: "Your article is scheduled for publication, display date must be set to the publish date.",
    publishDateChangeAfterPublished: "Warning: Change the publish date only after consultation with the SEO team!",
    originalBrand: "Original brand",
    originalArticleUrl: "Original article URL"
  },
  newsArticleList: {
    title: "Article",
    newButton: "New Article",
    multiLabel: "Save selected Articles",
    search: "Search by kicker, title or Legacy-ID",
    myArticles: "My articles",
    includeSubchannels: "Include subchannels",
    statusDropdown: "Status",
    statusAll: "All",
    statusDraft: "Draft",
    statusSchedule: "Schedule",
    statusPublished: "Published",
    statusUnpublish: "Offline",
    typeDropdown: "Article type",
    typeAll: "All",
    typeImages: "Images",
    typeVideos: "Videos",
    typeGalleries: "Galleries",
    displayDateFrom: "Show from",
    displayDateTo: "Show to",
    displayPeriod: "Period",
    isPremium: "Only Inside articles",
    isBought: "Article bought",
    contentPartner: "Content Partner",
    loading: "Loading Articles",
    deleteArticle: "Delete Article",
    headerStatus: "Status",
    headerKickerTitle: "Kicker, Title",
    headerChannel: "Channel",
    headerPublished: "Shown date",
    headerChanged: "Changed at",
    headerAMP: "AMP",
    headerBrand: "Brand",
    headerAMPDescription: "Green tick: The AMP version of the article is valid. It works on all Google platforms.\nRed Cross: The article contains elements that invalidate the AMP. Please check again.",
    multiSelect: "Select",
    dpEdit: "Edit",
    dpGoToArticle: "Go to Article",
    duplicateArticle: "Duplicate article",
    dpDelete: "Delete Article",
    messageNoSelfLink: "Article can't link to itself.",
    messageDelete1: "Are you sure you want to delete article",
    messageDelete2: "?",
    messageDeleteSuccess: "Article deleted",
    editNewTab: "Edit in new tab",
    scheduledChangeToolTipMessage: " Scheduled updates to this article are set for",
    authorshipType: "Authorship Type",
    authorshipTypeAll: "All",
    authorshipTypeNewsArticle: "News Article",
    authorshipTypePartnerArticle: "Partner Article",
    authorshipTypeCrossPublishArticle: "Cross Publish News Article",
    authorshipTypeAgencyArticle: "Agency Article",
    excludeFeedsLabel: "Exclude Feeds",
    excludeFeedsNone: "None",
    noTagFilterLabel: "All articles"
  },
  articlesEdit: {
    kicker: "Kicker (please do not fill in for CHIP)",
    title: "Title",
    people: "People",
    leadText: "Lead Text",
    words: "Words",
    chars: "Characters",
    addContent: "Add content",
    remove: "remove",
    externalSource: "External source",
    excludedSources: "Excluded external sources",
    channel: "Channel",
    articleTitle: "Article Title",
    seoTitle: "SEO Title",
    articleType: "Article Type",
    image: "Image",
    video: "Video",
    gallery: "Gallery",
    imageSelector: "Select or upload main image",
    mainImageTitle: "Main image",
    mainVideoTitle: "Main video",
    teaserVideoTitle: "Preview video",
    teaserImageTitle: "Teaser image",
    mainImageTitleTooltip: "The main image is displayed on the article page.",
    mainVideoTitleTooltip: "The main video is displayed on the article page.",
    teaserVideoTitleTooltip: "The preview video is displayed on the article page.",
    teaserImageTitleTooltip: "The teaser image is displayed on channel pages.",
    teaserImageSelector: "Select or upload teaser image",
    teaserInfo: "If no teaser image exists the main image will be used on channel pages",
    teaserInfoVideo: "If no teaser image exists the video image will be used on channel pages",
    gallerySelector: "Gallery image",
    teaserGalleryTitle: "Gallery images",
    teaserGalleryMainImageTitle: "Main Image",
    teaserGalleryMainImageLabel: "Select or upload the main image",
    teaserGalleryMainImageCheckbox: "Add to gallery",
    teaserGalleryMainImageCheckboxTooltip: "The main image will be added to the selected gallery.",
    gallerySelectorTooltip: "The gallery image is displayed on the article page.",
    teaserGalleryMainImageTitleTooltip: "The main image is optional.",
    teaserImageGallery: "Select or upload teaser image",
    dateSettingsTitle: "Publishing settings",
    showFirstPublishDate: "Show first publish date",
    videoAutoplay: "Autoplay",
    articleDisplayDate: "Shown date",
    noPublishDate: "Publish date",
    setPublishDate: "Publish at",
    setUnpublishDate: "Take offline at",
    relatedDeleted: "Deleted",
    relatedExpired: "Expired",
    relatedWeight: "Weight",
    relatedRemove: "Remove",
    relatedPlaceHere: "Place articles here",
    relatedPrioAd: "AD",
    relatedPrioInside: "LOGIN",
    relatedArticleAdd: "Link article",
    seoPerfect: "Perfect Length",
    seoOkay: "Okay, shorten if possible",
    seoLong: "Too long, please shorten!",
    length: "Length",
    desktopAlertTitle: "An error has occurred",
    desktopAlertDescription: "Your resolution is currently too low to display the desktop preview.<br/>Please minimize the menu on the left to display the desktop preview.",
    addPeople: "Add People",
    sourceTracking: "Source tracking",
    communityTracking: "Community tracking",
    seoDescriptionLabel: "Are you sure you want to change the meta description? This will no longer include future changes to the contents in the meta description automatically.",
    seoDescriptionConfirm: "OK",
    seoDescriptionCancel: "Cancel",
    teaserDialogTitle: "Deactivating teaser texts",
    teaserDialogMsg: "Are you sure you want to deactivate the different teaser texts? This will lead to the texts not being used after saving the article.",
    teaserDialogConfirm: "OK",
    teaserDialogCancel: "Cancel",
    teaserEnabled: "Teaser inputs created",
    updateShownDateCheckboxHint: "Automatically update the shown date to the current timestamp when you save or publish the article.",
    updatePublishDateCheckboxHint: "Automatically updates the publish date value to the selected date for the change",
    linkTags: "Link Tags",
    articlePushHistory: "Article Push History",
    feedSettings: {
      title: "Feeds",
      description: "The article will be included in the following feeds:",
      options: {
        include: "Yes",
        exclude: "No",
        auto: "Auto"
      }
    },
    selectedPartnerImageWarning: "You have selected partner image. This image may only be used in the corresponding partner article."
  },
  articleBlocks: {
    ctaLayout: "Layout",
    ctaButton: "Button",
    ctaStickyButton: "Sticky Button",
    ctaBox11: "Box 1:1",
    ctaBox11Info: "Box with Image in 1:1 Format",
    ctaBox169: "Box 16:9",
    ctaBox169Info: "Box with Image in 16:9 Format",
    ctaTitle: "Title",
    ctaButtonText: "Button Text (17 character limit)",
    ctaLink: "Button Link",
    ctaIsAffiliate: "Show affiliate disclaimer",
    noFollow: "No Follow",
    noFollowTooltip: "The link will be labeled as 'nofollow'. Please always select nofollow for commercial links.",
    blockTeaser: "Article Teaser",
    imageUrl: "Image URL",
    imagePlaceholder: "Link URL, must start with https://",
    hasAffiliate: "Affiliate Link",
    hasAffiliateTooltip: "If a link is labeled as an affiliate link, the affiliate disclaimer box will appear at the top of the article and the element will be marked as an advertisement.",
    newTab: "Open in new tab",
    bound: "Bound",
    boundTooltip: "By default the Banner appears standalone and not bound to the subsequent Stage.",
    loginwallText: "Customers can register here to see more content. Logged in users don't see this element.",
    quoteAuthor: "Quote from",
    scriptBlock: "Insert custom JavaScript (will NOT be shown in AMP). Please be aware of the GDPR issues when used.",
    rawBlock: "Insert custom JavaScript (shown on AMP). Please be aware of the GDPR issues when used.",
    becomeInsider: "Become an INSIDER and continue reading",
    highlightBox: "Highlight Box",
    labelText: "Text field",
    labelImage: "Image",
    labelGallery: "Gallery",
    labelVideo: "Video",
    labelArticle: "Article",
    labelPaywall: "Paywall",
    labelLoginwall: "Login",
    labelSocial: "Social",
    labelQuote: "Quote",
    labelCTA: "Call to action",
    labelNewsletter: "Newsletter Box",
    or: "OR",
    imageLink: "Alternatively add image via image link",
    imageUrlStart: "Image Url, must start with https://",
    imagePreview: "Vorschau"
  },
  articlesVersions: {
    noVersions: "No versions available",
    unknownEditor: "Editor unknown",
    modifiedBy: "Modified by",
    modifiedAt: "Modified at"
  },
  articlesMigration: {
    directEditNotice: "Please note: The settings visible here take effect immediately and are independent of the save function. Changes are applied instantly.",
    source: "Source",
    legacyId: "Legacy ID",
    renderedByCtf: "Rendered by CTF",
    editableInCtf: "Editable in Vibe",
    modifiedInCtf: "Modified in Vibe",
    confirmModal: {
      yes: "Yes",
      cancel: "Cancel",
      renderedBy: {
        title: "Changing Rendered by CTF",
        message: "Are you sure you want to change the rendering system?"
      },
      editableIn: {
        title: "Changing Editable in Vibe",
        message: "Are you sure you want to make the article editable in CTF? This cannot be undone!"
      }
    },
    viewCtfVersion: "View CTF version"
  },
  articleNotifications: {
    successfulMutation: {
      saved: "Article saved",
      deleted: "Deleted",
      published: "Published",
      unpublished: "Article offline",
      scheduled: "Scheduled",
      saveDraft: "Draft"
    },
    warnings: {
      empty: {
        image: "There is an empty image block that will be replaced with a placeholder.",
        video: "There is an empty video block that will be replaced with a placeholder.",
        text: "There is an empty text block.",
        social: "There is an empty social block that will be replaced with a placeholder.",
        gallery: "There is an empty gallery block that will be replaced with a placeholder.",
        chipWidget: "There is an empty chip widget block that will be get removed on saving.",
        cwcWidget: "There is an empty cwc widget block that will be get removed on saving.",
        inpageWidget: "There is an empty inpage widget block that will be get removed on saving.",
        backgroundArticle: "There is an empty background article block that will be replaced with a placeholder."
      }
    }
  }
};
const messages = { en, de };
const routes = [
  {
    path: `/${ROUTES.articles.path}`,
    meta: { i18RouteTitleKey: ROUTES.articles.path },
    children: [
      {
        path: "",
        name: "content_list",
        component: () => import("./content-list-SQJoIuNG.js"),
        meta: { requiredRight: "navigate_list_articles" },
        props: (route) => ({ source: route.query.source })
      },
      {
        path: "new",
        name: "content_new",
        component: () => import("./content-edit-RmIFsAUr.js").then((n) => n.x),
        props: (route) => ({ tab: route.query.tab, backRoute: "/articles" }),
        meta: { requiredRight: "navigate_article" }
      },
      {
        path: ":id",
        name: "content_edit",
        component: () => import("./content-edit-RmIFsAUr.js").then((n) => n.x),
        props: (route) => ({ id: route.params.id, tab: route.query.tab, backRoute: "/articles" }),
        meta: { requiredRight: "navigate_article" }
      }
    ]
  }
];
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "content-tags-dropdown.selector",
  props: /* @__PURE__ */ mergeModels({
    noTagFilterLabel: { type: String, required: false, default: "newsArticleList.noTagFilterLabel" },
    disable: { type: Boolean, required: false, default: false }
  }, {
    "modelValue": { type: null },
    "modelModifiers": {}
  }),
  emits: /* @__PURE__ */ mergeModels(["change:tag", "click:already-selected-tag"], ["update:modelValue"]),
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const { t } = useI18n();
    const props = __props;
    const selectedTag = useModel(__props, "modelValue");
    const emit = __emit;
    function onTagClick(clickedTag) {
      if (selectedTag.value === clickedTag) {
        emit("click:already-selected-tag");
      }
    }
    const getTagOptions = computed(() => {
      return [{ label: t(props.noTagFilterLabel), value: "" }, ...TAG_OPTIONS.map((tag) => ({ label: tag.title, value: tag.id }))];
    });
    const __returned__ = { t, props, selectedTag, emit, onTagClick, getTagOptions, get QItem() {
      return QItem;
    }, get QItemSection() {
      return QItemSection;
    }, get QSelect() {
      return QSelect;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const _hoisted_1 = { class: "no-wrap" };
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock($setup["QSelect"], {
    modelValue: $setup.selectedTag,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event) => $setup.selectedTag = $event),
      _cache[1] || (_cache[1] = ($event) => $setup.emit("change:tag", $setup.selectedTag))
    ],
    "data-qa-content-tag-dropdown": $setup.selectedTag,
    options: $setup.getTagOptions,
    "emit-value": "",
    "map-options": "",
    dense: "",
    flat: "",
    "dropdown-icon": "expand_more",
    outlined: "",
    disable: $props.disable
  }, {
    "selected-item": withCtx((scope) => [
      createElementVNode(
        "div",
        _hoisted_1,
        toDisplayString(scope.opt.label),
        1
        /* TEXT */
      )
    ]),
    option: withCtx((scope) => [
      createVNode($setup["QItem"], mergeProps(scope.itemProps, {
        "data-qa-content-tag-dropdown-option": scope.opt.value,
        onClick: ($event) => $setup.onTagClick(scope.opt.value)
      }), {
        default: withCtx(() => [
          createVNode(
            $setup["QItemSection"],
            null,
            {
              default: withCtx(() => [
                createTextVNode(
                  toDisplayString(scope.opt.label),
                  1
                  /* TEXT */
                )
              ]),
              _: 2
              /* DYNAMIC */
            },
            1024
            /* DYNAMIC_SLOTS */
          )
        ]),
        _: 2
        /* DYNAMIC */
      }, 1040, ["data-qa-content-tag-dropdown-option", "onClick"])
    ]),
    _: 1
    /* STABLE */
  }, 8, ["modelValue", "data-qa-content-tag-dropdown", "options", "disable"]);
}
const contentTagsDropdown_selector = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render$1], ["__file", "/builds/CT/content-technology-framework/modules/news-article/editor-ui/src/components/content-tags-dropdown.selector.vue"]]);
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "table-of-contents-input",
  props: /* @__PURE__ */ mergeModels({
    locked: { type: Boolean, required: false, default: false }
  }, {
    "modelValue": { type: String },
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {
    __expose();
    const { t } = useI18n();
    const contentStore = useEditorContent();
    const hasTableOfContents = computed(() => !!contentStore.content.hasTableOfContents);
    const model = useModel(__props, "modelValue");
    const __returned__ = { t, contentStore, hasTableOfContents, model, get VuetifyValidationRules() {
      return VuetifyValidationRules;
    }, get QInput() {
      return QInput;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return $setup.hasTableOfContents ? (openBlock(), createBlock($setup["QInput"], mergeProps({ key: 0 }, _ctx.$attrs, {
    modelValue: $setup.model,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.model = $event),
    dense: "",
    outlined: "",
    type: "text",
    label: $setup.t("common.tableOfContentsText"),
    rules: [$setup.VuetifyValidationRules.maxLength(100)],
    disable: $props.locked,
    readonly: $props.locked,
    class: "q-mb-md",
    "hide-bottom-space": "",
    "data-qa-article-content-text-block-table-of-contents-input": ""
  }), null, 16, ["modelValue", "label", "rules", "disable", "readonly"])) : createCommentVNode("v-if", true);
}
const tableOfContentsInput = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/builds/CT/content-technology-framework/modules/news-article/editor-ui/src/components/table-of-contents-input.vue"]]);
const ContentEdit = defineAsyncComponent(() => import("./content-edit-RmIFsAUr.js").then((n) => n.x));
const ContentList = defineAsyncComponent(() => import("./content-list-SQJoIuNG.js"));
const LinkEntitiesView = defineAsyncComponent(() => import("./link-entities.view-DYIsu7wM.js"));
const ContentsListSelector = defineAsyncComponent(() => import("./contents-list-selector-B8Z4udMZ.js"));
const ContentListSelector = defineAsyncComponent(() => import("./content-list-selector-CVfIgeg0.js"));
const contentModule = {
  messages,
  routes,
  contentBlocks: []
};
export {
  ContentEdit as C,
  LinkEntitiesView as L,
  _export_sfc as _,
  ContentList as a,
  ContentsListSelector as b,
  ContentListSelector as c,
  contentModule as d,
  contentTagsDropdown_selector as e,
  tableOfContentsInput as t
};
//# sourceMappingURL=index-Bwtbrhf1.js.map
